// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PVerticalAlignTopOutlinedSvg from "@fishx/icons-svg/es/asn/PVerticalAlignTopOutlined";
import FishxIcon from '../components/FishxIcon';

var PVerticalAlignTopOutlined = function PVerticalAlignTopOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PVerticalAlignTopOutlinedSvg
  }));
};

PVerticalAlignTopOutlined.displayName = 'PVerticalAlignTopOutlined';
export default React.forwardRef(PVerticalAlignTopOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PVerticalAlignTopOutlined.js
// module id = 3719
// module chunks = 0